import * as yup from 'yup';

export const contactRequestSchema = yup.object().shape({
  moveinDate: yup.string().notRequired(),
  moveoutDate: yup.string().notRequired(),
  daysPerWeek: yup.string().nullable().notRequired(),
  requiredCapacity: yup.string().nullable().notRequired(),
});
